import createSvgIcon from '../Utils/CreateSvgIcon';

export const Hamburger = createSvgIcon(
  <path d="M2 4H22V6L2 6V4ZM2 11L22 11V13L2 13V11ZM22 18L2 18V20H22V18Z" />,
  'Hamburger',
);
